<form [formGroup]="mainForm">
<!--  <h1>{{ organizationDetails.OrganizationName }}</h1>-->
      <div class="p-grid p-fluid no-margin">

        <div class="col-md-6 col-sm-12 col-xs-12 input-container">
          <label>Password<span class="req"> *</span></label>
          <input [type]="passwordType" class="p-mb-2" pInputText formControlName="password">
          @if (mainForm.controls.password.invalid && mainForm.controls.password.dirty) {
            <div class="p-error">
              @if (mainForm.controls.password.errors?.required) {
                <div>New Password is required</div>
              }
              <!--                <div *ngIf="changePasswordForm.controls.password.errors?.pattern">Must contain at least one uppercase and lowercase letter, one number, one special character, and be at least 10 characters long</div>-->
              @if (mainForm.controls.password.hasError('length')) {
                <div>Must be at least 10 characters long</div>
              }
              @if (mainForm.controls.password.hasError('uppercase')) {
                <div>Must contain at least one uppercase letter (A-Z)</div>
              }
              @if (mainForm.controls.password.hasError('lowercase')) {
                <div>Must contain at least one lowercase letter (a-z)</div>
              }
              @if (mainForm.controls.password.hasError('number')) {
                <div>Must contain at least one number (0-9)</div>
              }
              @if (mainForm.controls.password.hasError('special')) {
                <div [innerHTML]="'Must contain at least one special character ($@#!%*?&)'"></div>
              }
              @if (mainForm.controls.password.hasError('repeats')) {
                <div>Must have no more than 2 identical characters in a row (999 not allowed)</div>
              }
              @if (mainForm.controls.password.hasError('customValidator')) {
                <div>No parts of your username</div>
              }
            </div>
          }
          <div class="checkbox-container p-pt-0">
            <p-checkbox class="p-mb-2" [binary]="true" formControlName="showPassword"></p-checkbox>
            <label class="add-display-inline force-auto-width">Show Password</label>
          </div>
        </div>
        <div class="col-md-6 col-sm-12 col-xs-12 input-container">
          <label>Confirm Password<span class="req"> *</span></label>
          <input [type]="passwordConfirmType" class="p-mb-2" pInputText formControlName="passwordConfirm">
          @if (mainForm.controls.passwordConfirm.invalid && mainForm.controls.passwordConfirm.dirty) {
            <div class="p-error">
              @if (mainForm.controls.passwordConfirm.errors?.required) {
                <div>Confirm New Password is required</div>
              }
              @if (mainForm.controls.passwordConfirm.errors?.confirmedValidator) {
                <div>New Password & Confirm New Password do not match</div>
              }
            </div>
          }
          <div class="checkbox-container p-pt-0">
            <p-checkbox class="p-mb-2" [binary]="true" formControlName="showPasswordConfirm"
            ></p-checkbox>
            <label class="add-display-inline force-auto-width">Show Password</label>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10 checkbox">
          <p-checkbox
            formControlName="agree"
            [value]="true"
            [binary]="true" />
          <label class="registration-label">I agree<sup class="req">*</sup></label>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
          <div class="legal-agreement">
            <div [innerHTML]="legal"></div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10">
        </div>
        <div class="contribution margin-top-10">
<!--          Amount: ${{ organizationDetails.ChargeAmount }}-->
        </div>
        <div class="next-page-button">
          @if (!isSaving) {
            <p-button label="Submit" (click)="goToNextPage()" [disabled]="mainForm.invalid"/>
          }
          @if (isSaving) {
            <p-button  label="Submit" class="p-button-info export-excel p-mr-2" [className]="'inline-button'"
                    [disabled]="true">
              <i class="pi pi-spin pi-spinner save-spinner"></i>
            </p-button>
          }
        </div>
      </div>
</form>
